<template>
  <span>
    Booking
    <router-link
      tag="a"
      :to="`/bookings/overview/:date?${eventLog.bookingId}`"
      >#{{ eventLog.bookingId }}
    </router-link>
    cancelled
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionBookingRefunded',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
